import axios from 'axios';

/**
   * Liste des actions
 */
export const Actions = {
    FETCH_SUGGESTIONS_ARTICLE_GESTION_REQUEST: 'FETCH_SUGGESTIONS_ARTICLE_GESTION_REQUEST',
    FETCH_SUGGESTIONS_ARTICLE_GESTION_SUCCESS: 'FETCH_SUGGESTIONS_ARTICLE_GESTION_SUCCESS',
    FETCH_SUGGESTIONS_ARTICLE_GESTION_FAILURE: 'FETCH_SUGGESTIONS_ARTICLE_GESTION_FAILURE',

    CLEAR_SUGGESTIONS_ARTICLE_GESTION: 'CLEAR_SUGGESTIONS_ARTICLE_GESTION',

    SET_ARTICLE_GESTION_VALUE: 'SET_SUGGESTIONS_ARTICLE_GESTION_VALUE',
    CLEAR_ARTICLE_GESTION_VALUE: 'CLEAR_SUGGESTIONS_ARTICLE_GESTION_VALUE'
};


/**
 * ActionCreator pour FETCH_SUGGESTIONS_...
 */
const fetchSuggestionsArticleGestionRequest = (namespace) => ({ type: `${namespace}/${Actions.FETCH_SUGGESTIONS_ARTICLE_GESTION_REQUEST}` });
const fetchSuggestionsArticleGestionSuccess = (namespace, articlesGestion) => ({ type: `${namespace}/${Actions.FETCH_SUGGESTIONS_ARTICLE_GESTION_SUCCESS}`, articlesGestion });
const fetchSuggestionsArticleGestionFailure = (namespace, error) => ({ type: `${namespace}/${Actions.FETCH_SUGGESTIONS_ARTICLE_GESTION_FAILURE}`, error });

/**
 * ActionCreator pour la récuperation des données (suggestions)
 */
export const fetchSuggestionsArticleGestion = (namespace, searchValue, infosLogistique = false) => async (dispatch) => {
    dispatch(fetchSuggestionsArticleGestionRequest(namespace));

    try {
        let response = await axios.get(`api/articles-gestion/suggestion?query=${searchValue}&infosLogistique=${infosLogistique}`);

        dispatch(fetchSuggestionsArticleGestionSuccess(namespace, response.data));

    } catch (error) {
        console.error('fetchSuggestionsArticleGestion : ', error);
        dispatch(fetchSuggestionsArticleGestionFailure(namespace, error));
    }
};

/**
 * ActionCreator pour CLEAR_SUGGESTIONS_ARTICLE_GESTION
 */
export const clearSuggestionsArticleGestion = (namespace) => ({ type: `${namespace}/${Actions.CLEAR_SUGGESTIONS_ARTICLE_GESTION}` });

/**
 * ActionCreator pour SET_ARTICLE_GESTION_VALUE
 */
export const setArticleGestionValue = (namespace, value, suggestion) => ({ type: `${namespace}/${Actions.SET_ARTICLE_GESTION_VALUE}`, value, suggestion });

/**
 * ActionCreator pour CLEAR_ARTICLE_GESTION_VALUE
 */
export const clearArticleGestionValue = (namespace) => ({ type: `${namespace}/${Actions.CLEAR_ARTICLE_GESTION_VALUE}` });